import { NgFor, NgIf, NgStyle } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { RouterLink, RouterModule } from "@angular/router";
import { IconFacebookComponent } from "@src/app/components/svg/icon-facebook/icon-facebook.component";
import { IconLinkedinComponent } from "@src/app/components/svg/icon-linkedin/icon-linkedin.component";
import { IconShareComponent } from "@src/app/components/svg/icon-share/icon-share.component";
import { IconTwitterComponent } from "@src/app/components/svg/icon-twitter/icon-twitter.component";
import { IconWhatsappComponent } from "@src/app/components/svg/icon-whatsapp/icon-whatsapp.component";
import { KebabCasePipe } from "@src/app/pipes/kebab-case.pipe";
import { ConfigService } from "@src/app/servicios/config/config.service";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";
@Component({
  selector: "app-noticias-horizontal",
  imports: [RouterModule, RouterLink, NgStyle, KebabCasePipe, NgFor, NgIf, IconFacebookComponent, IconTwitterComponent, IconWhatsappComponent, IconLinkedinComponent, IconShareComponent, SkeletonImageComponent],
  templateUrl: "./noticias-horizontal.component.html",
  styleUrl: "./noticias-horizontal.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticiasHorizontalComponent implements OnChanges {
  @Input() noticias = [];
  @ViewChild("container", { static: false }) container: ElementRef;
  constantesGlobales;
  attempts = 0;
  noticiasUpdated: any[] = [];

  miniSrc: string;
  miniSrcDefault: string;
  rrssVisible: boolean[] = [];

  constructor(
    private readonly configService: ConfigService,
    private readonly elementRef: ElementRef,
  ) {
    this.constantesGlobales = this.configService.getConstantesGlobales();
    this.elementRef.nativeElement.style.setProperty("--background-color", this.constantesGlobales.color);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["noticias"] && changes["noticias"].currentValue) {
      this.rrssVisible = new Array(this.noticias.length).fill(false);
    }
  }

  mostrarRRSS(index): void {
    this.rrssVisible[index] = !this.rrssVisible[index];
  }
  generateMiniSrc(src) {
    this.miniSrcDefault = src.replace(/caratula/i, "caratula_320");
    return this.miniSrcDefault;
  }

  trackByNoticia(index: number, noticia: any): string | number {
    return noticia?.id || index;
  }
}
